const PaginationDropdown = ({ onChange }) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <select
        className="ct_pagination_select_21"
        onChange={(e) => onChange(e.target.value)}
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={250}>250</option>
      </select>
    </div>
  );
};

export default PaginationDropdown;
